import React from 'react';
import { IFilterAPIModel } from '../../models/IAllOpportunitiesModel';
import {BADGE_CLASSNAMES, BADGE_NAMES, BADGE_VALUES} from 'src/constants/constants';
import { FilterOption } from 'src/models/IOverviewModel';
import { getMessage } from 'src/message/utils';

interface IOvervewBadgeModal {
    onRemoveBadge: Function;
    filters: IFilterAPIModel[];
    onClearOverviewFilter: Function;
    totalRecord?: any;
}

export const OverviewBadges = (props: IOvervewBadgeModal) => {
    const badgeDom = (item: any) => {
        const badgeClass=BADGE_CLASSNAMES?.[item.column as keyof typeof BADGE_CLASSNAMES] || '';
        if(item.column === 'dollar_value' || item.column === 'created_on') {
            return <div className={`badges_block ${badgeClass}`}>
            {`${BADGE_NAMES[item.column as keyof typeof BADGE_NAMES]}: ${item.value[0]}  -  ${item.value[1]}`}<span className="badges_close" onClick={() => props.onRemoveBadge(item.column, '0')}>X</span></div>
        } else {
            let badgeValues = item.displayValues && Array.isArray(item.displayValues) ? 
                [...item.displayValues] : (Array.isArray(item.value) ? [...item.value] : []);
            if (item.displayValues && Array.isArray(item.displayValues)) {
                badgeValues = item.displayValues.map((badgeItem: string, index: number)=> {
                    return {
                        text: badgeItem,
                        value: item.value[index]
                    }
                });
            } else {
                badgeValues = item.value.map((badgeItem: string, index: number)=> {
                    return {
                        text: badgeItem,
                        value: badgeItem
                    }
                });
            }
            return badgeValues.map((val: FilterOption, indexVal: any) => {
                return <div key={indexVal} className={`badges_block ${badgeClass}`}>
                    {`${BADGE_NAMES[item.column as keyof typeof BADGE_NAMES] || item.column}: ${BADGE_VALUES[val.text as keyof typeof BADGE_VALUES] || val.text}`}<span className="badges_close" onClick={() => props.onRemoveBadge(item.column, val)}>X</span></div>
            })
        }
    }
    const badgeFilters = props.filters.filter(item => !(item.value.includes("All") || item.value.includes("all")));
    const noFilterAppliedText = getMessage('app.anomalies.action.filter.nofilterapplied');
    const clearFiltersText = getMessage('app.anomalies.action.filter.clearfilters');
    return (
        <>
         <div className="allopportunity__filters-info--badges">
            {
                badgeFilters.length === 0 ?
                    <span>{noFilterAppliedText}</span>
                    : <div className="badges">
                        {badgeFilters.map((item: any) => {
                            return (
                                <>
                                    {badgeDom(item)}
                                </>
                            )
                        })}
                        
                    </div>
            }
        </div>
        {badgeFilters.length > 0 && <div className={props.totalRecord >=10 ? "badges_clear-filter badges_reset-position" : "badges_clear-filter"} onClick={() => props.onClearOverviewFilter()}  >{clearFiltersText}</div>}
        </>
       

    );
}

